import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const ProtectedRoute = ({ children, requireEmailVerification = true }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    // Contextual reason for the redirect, shown on the login page. The
    // contractor / verifier directories are gated because Eqaya pays to vet
    // them — they are not browsable without an account.
    const noticeByPath = {
      '/contractors': 'Please sign in or create a free account to view our verified contractors.',
      '/verifiers': 'Please sign in or create a free account to view our independent verifiers.',
    };
    const notice = noticeByPath[location.pathname] || 'Please sign in to continue.';
    return <Navigate to="/login" state={{ from: location, notice }} replace />;
  }

  // Check email verification if required
  // Skip verification for OAuth users (Google, Facebook, etc.) as their email is pre-verified
  if (requireEmailVerification && user) {
    const authProvider = user.authProvider || user.auth_provider || 'local';
    const emailVerified = user.emailVerified || user.email_verified;
    
    // OAuth users skip email verification
    if (authProvider === 'local' && !emailVerified) {
      return <Navigate to="/verify-email" state={{ from: location }} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
